import React, { Component, Fragment } from "react";
import PropTypes from "proptypes";
import { seatsLeftEvaluator } from "./../../../helpers/TripHelper";

import "./TripList.scss";

export default class Trip extends Component {
  state = {
    toggledIndeces: [],
    locations: ['Nepal', 'Laos', 'Tanzania', 'Nicaragua', 'Thailand', 'WILD']
  };

  componentDidMount() {
    for (let trip of this.props.trips) {
      trip.dates.sort(
        (a, b) =>
          a.startDate > b.startDate ? 1 : a.startDate < b.startDate ? -1 : 0
      );
    }
  }

  toggleAddOnDescription = (e, addOnIndex) => {
    e.preventDefault();

    const { toggledIndeces } = this.state;

    if (!toggledIndeces.includes(addOnIndex)) {
      toggledIndeces.push(addOnIndex);
      this.setState({
        toggledIndeces
      });
    } else {
      toggledIndeces.splice(toggledIndeces.indexOf(addOnIndex), 1);
      this.setState({
        toggledIndeces
      });
    }
  };

  desinationHasLocationInName(tripName) {
    for (const location of this.state.locations) {
      if (tripName.indexOf(location) >= 0) {
        return true;
      }
    }
    return false;
  }

  currencyFormatter = new Intl.NumberFormat("en-US", {
    style: "currency",
    currency: "USD",
    minimumFractionDigits: 0
  });

  render() {
    const {
      name,
      content,
      id,
      approved,
      hasRegisteredForTrip,
      onSelectingTrip,
      cartIsEmpty,
      pathname
    } = this.props;
    const trips = this.props.trips.sort(function(a, b) {
      return a.name.length - b.name.length;
    });
    return (
      <div id={id} className="trips-wrapper">
        <div className="row">
          <div className="col-md-12 no-padding-col">
            <h3 className="h1-style success" id={`${id}-tag`}>
              {name}
            </h3>
            {content !== undefined && Object.keys(content).length ? (
              <Fragment>
                {(content.videoUrl || content.imageUrl) &&
                content.description ? (
                  <div className="col-md-4 padding-right">
                    {!content.videoUrl || content.videoUrl === undefined ? (
                      <img
                        className="trip-image"
                        src={`${content.imageUrl}`}
                        alt="destination"
                      />
                    ) : (
                      <div className="resp-container">
                        <iframe
                          id={content.id}
                          className="resp-iframe"
                          title="add-on video"
                          frameBorder="0"
                          padding="0"
                          margin="0"
                          allowFullScreen
                          allow="encrypted-media;"
                          src={content.videoUrl.replace(
                            "youtu.be/",
                            "www.youtube.com/embed/"
                          )}
                        />
                      </div>
                    )}
                  </div>
                ) : (
                  ""
                )}
                {content.description ? (
                  <div
                    className={`no-padding-col ${
                      !content.imageUrl && !content.videoUrl
                        ? "col-md-12"
                        : "col-md-8"
                    } `}
                  >
                    <p className="trip-description no-margin-text">
                      {content.description}
                    </p>
                  </div>
                ) : (
                  ""
                )}
              </Fragment>
            ) : (
              ""
            )}
          </div>
        </div>
        {trips.map(trip => (
          <div key={trip.id} className="row trip">
            <div className="col-md-12 no-padding-col">
              <strong>
                <h4 className="success">{trip.name} trip dates</h4>
              </strong>
              {trip.dates.map(date => (
                <Fragment key={date.id}>
                  {hasRegisteredForTrip(date.id) ? (
                    ""
                  ) : (
                    <div className="col-sm-4">
                      {pathname !== "/trip-selection" && approved === false ? (
                        <p
                          className={`details-group ${
                            date.displaySeatsLeft < 1 ? "disabled" : ""
                          }`}
                        >
                          {date.name}
                          {(date.name.indexOf('*') > 0) ?
                            ' ' + date.name.substring(date.name.indexOf('*'))
                            : ''
                          }
                          <span className="muted">
                            {trip.tripPrice}
                          </span>
                          <span className="error">
                            {seatsLeftEvaluator(date.displaySeatsLeft)}
                          </span>
                        </p>
                      ) : (
                        <Fragment>
                          <div className="col-sm-2 flex-align-center">
                            <input
                              onClick={e => {
                                onSelectingTrip(e, {
                                  id: `${name}-${date.id}`,
                                  name: date.name,
                                  startDate: date.startDate,
                                  endDate: date.endDate
                                });
                              }}
                              className="trip-radio"
                              type="radio"
                              disabled={date.displaySeatsLeft < 1}
                              id={`${name}-${date.id}`}
                            />
                          </div>
                          <div className="col-sm-10 flex-align-center">
                            <label
                              htmlFor={`${name}-${date.id}`}
                              className={`details-group ${
                                date.displaySeatsLeft < 1 ? "disabled" : ""
                              }`}
                            >
                              <span className="destination-name">{date.name}</span>
                              <span className="small">
                                  {(date.name.indexOf('*') > 0) ?
                                    ' ' + date.name.substring(date.name.indexOf('*'))
                                    : ''
                                  }
                                </span>
                                <div className="error">
                                  {seatsLeftEvaluator(date.displaySeatsLeft)}
                                </div>
                                <div className="price-block">
                                  {date.displayprice > (date.tripPrice - date.tripDiscount) ?
                                    <span className="list-price">{this.currencyFormatter.format(date.displayprice)}</span>
                                    : ''
                                  }
                                  <span className="current-price">{this.currencyFormatter.format(date.tripPrice - date.tripDiscount)}</span>
                                  {date.displayprice > (date.tripPrice - date.tripDiscount) ?
                                    <span className="savings">{this.currencyFormatter.format(date.displayprice - date.tripPrice + date.tripDiscount)} OFF</span>
                                    : ''
                                  }
                                </div>
                            </label>
                          </div>
                        </Fragment>
                      )}
                    </div>
                  )}
                </Fragment>
              ))}
              <Fragment>
                {cartIsEmpty &&
                trip.addOns !== undefined &&
                trip.addOns.length ? (
                  <Fragment>
                    <div className="col-md-12">
                      <h5 className="success lighter">
                        Add-Ons for {trip.name}
                      </h5>
                      <p>
                        You can register for the add-on(s) displayed below on
                        the next page after confirming a destination.
                      </p>
                      {trip.addOns.map((addOn, idx) => (
                        <div className="col-md-4 padding-right" key={addOn.id}>
                          <h5 className="addon-title">
                            <span className="icon-container world-icon" />
                            {addOn.title}{" "}
                          </h5>
                          {addOn.imageUrl &&
                          addOn.imageUrl !== undefined &&
                          (!addOn.videoUrl || addOn.videoUrl === undefined) ? (
                            <div className="padding-right col-md-12 add-on-image-container">
                              <img
                                id="addon-img"
                                src={addOn.imageUrl}
                                alt={addOn.title}
                              />
                            </div>
                          ) : (
                            ""
                          )}
                          {addOn.videoUrl && addOn.videoUrl !== undefined ? (
                            <div className="padding-right col-md-12">
                              <div className="resp-container">
                                <iframe
                                  id={addOn.id}
                                  className="resp-iframe"
                                  title="add-on video"
                                  frameBorder="0"
                                  padding="0"
                                  margin="0"
                                  allowFullScreen
                                  allow="autoplay; encrypted-media"
                                  src={addOn.videoUrl.replace(
                                    "youtu.be/",
                                    "www.youtube.com/embed/"
                                  )}
                                />
                              </div>
                            </div>
                          ) : (
                            ""
                          )}
                          <button
                            className="btn-plain-text small"
                            onClick={e => {
                              this.toggleAddOnDescription(e, idx);
                            }}
                          >
                            {this.state.toggledIndeces.includes(idx)
                              ? "Hide"
                              : "Show"}{" "}
                            volunteer trip details
                          </button>
                          {this.state.toggledIndeces.includes(idx) ? (
                            <p className="trip-description no-margin-text padding-right">
                              {addOn.description}
                            </p>
                          ) : (
                            ""
                          )}
                        </div>
                      ))}
                    </div>
                  </Fragment>
                ) : (
                  ""
                )}
              </Fragment>
            </div>
          </div>
        ))}
      </div>
    );
  }
}

Trip.propTypes = {
  name: PropTypes.string.isRequired,
  content: PropTypes.shape({
    description: PropTypes.string,
    videoUrl: PropTypes.string,
    imageUrl: PropTypes.string
  }),
  id: PropTypes.string.isRequired,
  approved: PropTypes.bool.isRequired,
  cartIsEmpty: PropTypes.bool.isRequired,
  trips: PropTypes.arrayOf(
    PropTypes.shape({
      destinationId: PropTypes.string,
      id: PropTypes.string,
      startDate: PropTypes.string,
      endDate: PropTypes.string,
      displaySeatsLeft: PropTypes.number
    })
  ).isRequired,
  hasRegisteredForTrip: PropTypes.func.isRequired,
  onSelectingTrip: PropTypes.func.isRequired,
  pathname: PropTypes.string.isRequired
};

Trip.defaultProps = {
  content: {
    description: "",
    videoUrl: "",
    imageUrl: ""
  }
};
